import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';

export const fetchBSReport = createAsyncThunk(
	'user/fetchBSReport',
    async ({user}) => {
        try {
            const bsReport = await fetchFun(`/api/v1/balance-sheet?userId=${user?._id}`);
            if(bsReport?.success) {
                return bsReport.data
            }
        } catch(error) {
            console.log("Error - /balance-sheet", error)
        }
    }
)